import React from 'react';
import { Check, ChevronRight, AlertCircle } from 'lucide-react';
interface TaskItemProps {
  id: string;
  title: string;
  description?: string;
  status: 'pending' | 'in-progress' | 'completed' | 'flagged';
  onClick: () => void;
  assignee?: string;
}
export const TaskItem: React.FC<TaskItemProps> = ({
  title,
  description,
  status,
  onClick,
  assignee
}) => {
  return <button onClick={onClick} className="w-full text-left bg-white border border-gray-200 rounded-lg p-4 hover:bg-gray-50 transition-colors" data-id="element-179">
      <div className="flex justify-between items-center" data-id="element-180">
        <div className="flex-1" data-id="element-181">
          <div className="flex items-center" data-id="element-182">
            {status === 'completed' ? <div className="w-5 h-5 rounded-full bg-green-500 flex items-center justify-center mr-3 flex-shrink-0" data-id="element-183">
                <Check className="w-3 h-3 text-white" data-id="element-184" />
              </div> : status === 'flagged' ? <div className="w-5 h-5 rounded-full bg-red-500 flex items-center justify-center mr-3 flex-shrink-0" data-id="element-185">
                <AlertCircle className="w-3 h-3 text-white" data-id="element-186" />
              </div> : <div className="w-5 h-5 rounded-full border-2 border-gray-300 mr-3 flex-shrink-0" data-id="element-187" />}
            <h4 className="font-medium text-gray-900" data-id="element-188">{title}</h4>
          </div>
          {description && <p className="text-sm text-gray-500 mt-1 ml-8" data-id="element-189">{description}</p>}
          {assignee && <div className="mt-2 ml-8" data-id="element-190">
              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800" data-id="element-191">
                {assignee}
              </span>
            </div>}
        </div>
        <ChevronRight className="w-5 h-5 text-gray-400 flex-shrink-0" data-id="element-192" />
      </div>
    </button>;
};